import React from "react"
import { type QueryClient } from "@tanstack/react-query"
import { Outlet, rootRouteWithContext } from "@tanstack/react-router"

import { type AuthState } from "@/store/auth"
import { NotFoundView } from "@/components/views/not-found"

type RouterContext = {
  auth: AuthState
  queryClient: QueryClient
}

export const Route = rootRouteWithContext<RouterContext>()({
  component: RootComponent,
  notFoundComponent: NotFoundView,
})

function RootComponent() {
  return (
    <>
      <Outlet />
      <React.Suspense fallback={<></>}>
        <TanStackRouterDevtools initialIsOpen={false} />
      </React.Suspense>
    </>
  )
}

const TanStackRouterDevtools =
  import.meta.env.MODE === "production"
    ? () => null // Render nothing in production
    : React.lazy(() =>
        import("@tanstack/router-devtools").then(res => ({
          default: res.TanStackRouterDevtools,
        }))
      )
